import React from 'react';

/**
 * ActionBar
 * A flexible, wrapping action bar designed to prevent button overlapping and horizontal overflow on mobile screens.
 * Automatically stacks buttons neatly below 480px / 360px and ensures a 44px minimum touch target.
 */
export const ActionBar = ({ children, className = '', align = 'start' }) => {
  const alignClass = {
    start: 'justify-start',
    end: 'justify-end',
    center: 'justify-center',
    between: 'justify-between',
  }[align] || 'justify-start';

  const flattenChildren = (kids) =>
    React.Children.toArray(kids).reduce((acc, kid) => {
      if (React.isValidElement(kid) && kid.type === React.Fragment) {
        return acc.concat(flattenChildren(kid.props.children));
      }
      return acc.concat(kid);
    }, []);

  const items = flattenChildren(children);

  return (
    <div className={`flex flex-wrap items-center gap-2 sm:gap-3 w-full ${alignClass} ${className}`}>
      {items.map((child, index) => {
        if (!React.isValidElement(child)) return child;
        return React.cloneElement(child, {
          key: child.key != null ? child.key : index,
          style: { minHeight: '44px', ...child.props.style },
          className: `${child.props.className || ''} text-center font-semibold transition-colors flex-1 xs:flex-initial flex items-center justify-center px-4 py-2 sm:py-2.5 rounded-xl text-xs sm:text-sm`.trim(),
        });
      })}
    </div>
  );
};
